import {
  List,
  Datagrid,
  FunctionField,
  TextInput,
  BooleanInput,
  RaRecord,
} from 'react-admin';
import { NameInlineCell, AddressCell, StatusCell, CountsCell } from './cells';
import { compactDatagridSx } from '../../shared/listCells';
import { Stack } from '@mui/material';
import { SyncStatus } from '../SyncStatus';
import { menuLabel } from '../menuConfig';
import { SubcontractorRuleImportButton } from './SubcontractorRuleImport';

const filters = [
  <TextInput source="q" label="Nazwa, NIP, miasto" alwaysOn />,
  // `defaultValue`: filtr dodany z „Dodaj filtr” od razu działa (e2e, 28.09.2026).
  <BooleanInput source="blacklisted" label="Tylko zablokowani" defaultValue />,
  <BooleanInput source="active" label="Tylko aktywni w TMS" defaultValue />,
  <BooleanInput source="spozaTms" label="Spoza TMS" defaultValue />,
];

/**
 * Kartoteka kontrahentów — lista.
 *
 * Tożsamość pochodzi z TMS klienta i tam jest edytowana; u nas jest tylko do
 * odczytu. Flagi operacyjne (blokada) też jeszcze nie są edytowalne — to
 * osobna decyzja: kto może blokować kontrahenta i z jakim śladem.
 */
export const ContractorList = () => (
  <List
    filters={filters}
    sort={{ field: 'legalName', order: 'ASC' }}
    perPage={25}
    title={menuLabel('contractors')}
  >
    <Stack spacing={1}>
      {/* Kartoteka pochodzi z TMS (W12): kiedy ostatnio pobrana i z jakim wynikiem. */}
      <SyncStatus />
      {/* Lista reguł podwykonawców z pliku (fala B, 21.10.2026) — za przełącznikiem. */}
      <Stack direction="row">
        <SubcontractorRuleImportButton />
      </Stack>
    <Datagrid rowClick="show" bulkActionButtons={false} sx={compactDatagridSx}>
      <FunctionField label="Kontrahent" render={(r: RaRecord) => <NameInlineCell record={r} />} />
      <FunctionField label="Adres" render={(r: RaRecord) => <AddressCell record={r} />} />
      <FunctionField label="Stan" render={(r: RaRecord) => <StatusCell record={r} />} />
      <FunctionField label="Powiązania" render={(r: RaRecord) => <CountsCell record={r} />} />
    </Datagrid>
    </Stack>
  </List>
);
